import React from 'react';
import moment from 'moment';
import u from '../utilities/Utilities';
import store from 'store';
import "../styles/task-report.scss";
import "../styles/hoto-report.scss";

export default class HandoverReport extends React.Component{

    state={
        contentArray:[],
    }

    componentDidMount=()=>{
        const content = store.get("handover-report");
        const moddedContent=content.map(
            (item)=>{
                item.totalDefects = item.hoInventory.map(
                    (inventory)=>{
                        return (inventory.defects.length);
                    }
                ).reduce((partialSum, a) => partialSum + a, 0);
                item.photoRender=this.imageArrayBreak(item.hoPhotos);
                return item;
            }
        )
        this.setState({
            contentArray:moddedContent,
        });
    }

    setDef=(value,type)=>{
        if(!value){
            return "None";
        }
        else if(type == "datetime"){
            return moment(value).format("DD MMM YYYY - h:mma");
        }
        else if(type == "date"){
            return moment(value).format("DD MMM YYYY");
        }
        else if(type == "time"){
            return moment("2000-01-01T" + value).format("h:mma");
        }
        else if(type == "dow"){
            const labels = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
            let dow = "";
            for(var i=0; i<value.length; i++){
                if(value[i]){
                    dow = dow + ((dow.length > 0) ? " / " : "") + labels[i];
                }
            }
            return dow;
        }

        return value;
    };

    imageArrayBreak=(array)=>{
        if(!array){
            return [];
        }
        const isEven = (array.length % 2 == 0);
        let twoArray = [];
        let row = [];
        for(var i=0; i<array.length; i++){
            row.push(array[i]);
            if(i%2 == 1){
                //new object
                twoArray.push(row);
                row = [];
            }
        }
        if(!isEven){
            row.push[{}];
            twoArray.push(row);
        }
        return twoArray;
    }

    render=()=>{
        const contentArray=this.state.contentArray;
        return(
            <div>
              {
                contentArray.map(
                    (content,c)=>{
                        return (
                          <div className="task-report-container" key={c}>
                              <img className="report-header-image" src="/images/app/app-logo.png"/>
                              <div className="report-title">Handover Report</div>

                              <div className="report-section">
                                  <div className="report-section-title">Handover Details</div>
                                  <div className="report-table">
                                      <table>
                                          <tbody>
                                              <tr className="report-row-double">
                                                <td><b>Dormitory</b></td>
                                                <td>{this.setDef(content.dormName)}</td>
                                                <td><b>Entry ID</b></td>
                                                <td>{this.setDef(content.hotoID)}</td>
                                              </tr>

                                              <tr className="report-row-double">
                                                <td><b>Prepared By</b></td>
                                                <td>{this.setDef(content.hoStaffName)}</td>
                                                <td><b>Prepared On</b></td>
                                                <td>{this.setDef(content.handoverOn,"datetime")}</td>
                                              </tr>
                                          </tbody>
                                      </table>
                                  </div>
                              </div>

                              <div className="report-section">
                                  <div className="report-section-title">Estate Details</div>
                                  <div className="report-table">
                                      <table>
                                          <tbody>
                                              <tr>
                                                  <td className="report-item"><b>Client</b></td>
                                                  <td className="report-item">{this.setDef(content.clientName)}</td>
                                              </tr>
                                              <tr>
                                                  <td className="report-item"><b>Agreement</b></td>
                                                  <td className="report-item">{this.setDef(content.agreementReference)}</td>
                                              </tr>
                                              <tr>
                                                  <td className="report-item"><b>Location</b></td>
                                                  <td className="report-item">({content.estateType}) {this.setDef(content.estateLabel)}</td>
                                              </tr>
                                              <tr>
                                                  <td className="report-item"><b>Number of Beds</b></td>
                                                  <td className="report-item">{this.setDef(content.bedCount)}</td>
                                              </tr>
                                              <tr>
                                                  <td className="report-item"><b>Remarks</b></td>
                                                  <td className="report-item">{this.setDef(content.remarks)}</td>
                                              </tr>
                                          </tbody>
                                      </table>
                                  </div>
                              </div>

                              <div className="report-section">
                                  <div className="report-section-title">Handover Inventory</div>
                                  <div className="report-table">
                                      <table>
                                          <thead>
                                              <tr>
                                                  <th className='ho-sn'>Item</th>
                                                  <th className="ho-item"/>
                                                  <th className="ho-quantity">Quantity</th>
                                              </tr>
                                          </thead>
                                          <tbody>
                                              {
                                                  content.hoInventory.map(
                                                      (item,index)=>{
                                                          return (
                                                            <tr key={index}>
                                                                <td className="ho-sn">{index+1}.</td>
                                                                <td className="ho-item">{item.itemName}</td>
                                                                <td className="ho-quantity">{item.hoQuantity}</td>
                                                            </tr>
                                                          )
                                                      }
                                                  )
                                              }
                                          </tbody>
                                      </table>
                                  </div>
                              </div>

                              {
                                  (content.photoRender.length > 0)
                                      ?
                                      <div className="report-section">
                                          <div className="report-section-title">General Photos</div>
                                          <div className={"report-table" + ((content.photoRender.length < 2) ? " half" : "")}>
                                              <table>
                                                  <tbody>
                                                      {
                                                          content.photoRender.map(
                                                              (row,rowIndex)=>{
                                                                return(
                                                                    <tr key={rowIndex}>
                                                                        {
                                                                            row.map(
                                                                                (item,index)=>{
                                                                                    return(
                                                                                        <td className="report-item" key={index}>
                                                                                            <img src={item} className="report-image"/>
                                                                                        </td>
                                                                                    )
                                                                                }
                                                                            )
                                                                        }
                                                                    </tr>
                                                                )
                                                              }
                                                          )
                                                      }
                                                  </tbody>
                                              </table>
                                          </div>
                                      </div>
                                      :
                                      null
                              }

                              {
                                  (content.totalDefects > 0)
                                      ?
                                      <div className="report-section">
                                          <div className="report-section-title">Handover Defects</div>
                                          <div className="report-section-desc">
                                              Client will not be liable for any known defects recorded in this section when the asset is returned. Defects marked with a strike through have been rectified before takeover
                                          </div>
                                          <div className="report-table defect">
                                              <table>
                                                  <tbody>
                                                      {
                                                          content.hoInventory.map(
                                                              (item,index)=>{
                                                                  const hasDefects = (item.defects.length > 0);
                                                                  if(!hasDefects){
                                                                      return null;
                                                                  }
                                                                  return (
                                                                    <tr key={index}>
                                                                        <td className="ho-sn">{index+1}.</td>
                                                                        <td className="ho-item">
                                                                            {item.itemName}
                                                                            <ul className="defect-ul">
                                                                                {
                                                                                    item.defects.map(
                                                                                        (defect,d)=>{
                                                                                            return (
                                                                                                <li key={d} className="defect-li">
                                                                                                    <span className={"defect-quantity" + ((defect.resolveQuantity > 0) ? " resolved" : "")}>{defect.defectQuantity}</span>
                                                                                                    {
                                                                                                        (defect.resolveQuantity > 0)
                                                                                                            ?
                                                                                                            <span className="resolve-quantity">{(parseInt(defect.defectQuantity) - parseInt(defect.resolveQuantity))}</span>
                                                                                                            :
                                                                                                            null
                                                                                                    }
                                                                                                    <span> x {defect.label}</span>
                                                                                                </li>
                                                                                            )
                                                                                        }
                                                                                    )
                                                                                }
                                                                            </ul>
                                                                        </td>
                                                                        <td className="ho-defect-photo">
                                                                            {
                                                                                item.defects.map(
                                                                                    (defect,d)=>{
                                                                                        return defect.defectPhoto.map(
                                                                                            (photo,p)=>{
                                                                                                return (
                                                                                                    <img src={photo} key={d+"-"+p} className="defect-photo"/>
                                                                                                )
                                                                                            }
                                                                                        )
                                                                                    }
                                                                                )
                                                                            }
                                                                        </td>
                                                                    </tr>
                                                                  )
                                                              }
                                                          )
                                                      }
                                                  </tbody>
                                              </table>
                                          </div>
                                      </div>
                                      :
                                      <div className="report-section">
                                          <div className="report-section-title">Handover Defects</div>
                                          <div className="report-section-desc" style={{borderBottom:"1px solid #f4f4f4"}}>
                                              No defects have been found and recorded during the handover process for any of the inventory items listed above
                                          </div>
                                      </div>
                              }

                              <div className="report-section">
                                  <div className="report-section-title">Acknowledgement</div>
                                  <div className="report-section-desc">
                                      The contents of this handover report and inventory items have been duly verified by the following representatives
                                  </div>
                                  <div className="report-table">
                                      <table>
                                          <tbody>
                                              <tr className="report-row-double">
                                                <td><b>Representative 1</b></td>
                                                <td>
                                                    {
                                                        (content.hoPrimaryName)
                                                            ?
                                                            <span><b>{content.hoPrimaryType}</b><br/></span>
                                                            :
                                                            null
                                                    }
                                                    {this.setDef(content.hoPrimaryName)}
                                                </td>
                                                <td><b>Signature</b></td>
                                                <td style={{textAlign:"cener"}}>
                                                    {
                                                        (content.hoPrimarySign)
                                                            ?
                                                            <img src={content.hoPrimarySign} className="hoto-report-sign"/>
                                                            :
                                                            "None"
                                                    }
                                                </td>
                                              </tr>

                                              <tr className="report-row-double">
                                                <td><b>Representative 2</b></td>
                                                <td>
                                                    {
                                                        (content.hoSecondaryName)
                                                            ?
                                                            <span><b>{content.hoSecondaryType}</b><br/></span>
                                                            :
                                                            null
                                                    }
                                                    {this.setDef(content.hoSecondaryName)}
                                                </td>
                                                <td><b>Signature</b></td>
                                                <td style={{textAlign:"cener"}}>
                                                    {
                                                        (content.hoSecondarySign)
                                                            ?
                                                            <img src={content.hoSecondarySign} className="hoto-report-sign"/>
                                                            :
                                                            "None"
                                                    }
                                                </td>
                                              </tr>

                                          </tbody>
                                      </table>
                                  </div>
                              </div>
                          </div>
                        )
                    }
                )
              }
            </div>
        )
    }
}
